import { ChangeDetectorRef, Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { TournamentService } from '../../../services/tournament.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LogService } from '../../../services/log.service';
import { Tournament } from '../../../models/tournament';
import _ from 'lodash';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TournamentCardComponent } from '../../../components/tournament-card/tournament-card.component';
import { AuxiliarService } from '../../../services/auxiliar.service';

@Component({
  selector: 'app-tournaments-active',
  imports: [
    TournamentCardComponent,
    TranslateModule,
  ],
  templateUrl: './tournaments-active.component.html',
  styleUrl: './tournaments-active.component.scss'
})
export class TournamentsActiveComponent implements OnInit {
  private readonly destroy$ = inject(DestroyRef);
  public tournaments = computed(() => {
    const filter = this.auxiliarService.searchField();
    return _.filter(this.tournamentsRaw(), (t: Tournament) => {
      return _.some(['name', 'town', 'maxTeams', 'year'], (field: string) => {
        return _.includes(_.toLower(_.deburr(_.get(t, field))), filter);
      });
    });
  });
  private tournamentsRaw = signal<Tournament[]>([]);

  constructor(
    private auxiliarService: AuxiliarService,
    private cdr: ChangeDetectorRef,
    private logService: LogService,
    private tournamentService: TournamentService,
    private translate: TranslateService,
  ){}

  ngOnInit(): void {
    this.getTournaments();
  }

  public getTournaments(): void {
    this.tournamentService.getActiveTournaments().pipe(takeUntilDestroyed(this.destroy$)).subscribe({
      next: (res) => {
        this.logService.info('[Tournament] - getActiveTournaments', res);
        this.tournamentsRaw.set(_.get(res, 'body.data', []));
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.logService.error('[Tournament] - getActiveTournaments', err, this.translate.instant('error.tournaments-active'));
      }
    });
  }
}
